export default "__VITE_ASSET__CzsTcamN__"